// extracted by mini-css-extract-plugin
export default {"ImageGallery":"imsgesList_ImageGallery__I0LNl","Item":"imsgesList_Item__zAdfX","img":"imsgesList_img__X5jvX"};